import axios from 'axios'
export default {
  name: 'completo',
  components: { },
  data () {
    return {
      errores: [], carpeta: 0, biblioteca: 0, alertapedidoguardado: 0, pedido: '', sologuardar: ''
    }
  },
  props:['idnuevo', 'guardar'],
  mounted() {
    if (this.guardar === "1") {
      this.alertapedidoguardado = 1
      this.sologuardar = 1
      this.consultarpedidoapi()
    }
  },
  created () {
    if (this.guardar === "1") {
      this.alertapedidoguardado = 1
      this.sologuardar = 1
      this.consultarpedidoapi()
    }
  },
  methods: {
    consultarpedidoapi () {
      if (this.$store.getters.islogin === true){
          axios.get(this.$apibase+'gen/verpedido/', {
            params: {
              'id': this.idnuevo,'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.procesarpedido(response),  response => this.errorprocesarpedido(response) )
          .catch( response => this.errorprocesarpedido(response))
      } else {
        errorprocesarpedido ('notcred')
      }
    },
    procesarpedido: function (response) {
      this.pedido = response.data.pedido
    },
    errorprocesarpedido: function (response) {
    },
    loginmuebles: function () {
      window.location = this.$store.getters.urlsalida
    },
    volveratras: function (event) {
      this.$router.push('/listador')
    },
    verpedido: function () {
      this.$router.push('/pedidos')
    },
    consultarbiblioteca () {
      if (this.$store.getters.islogin === true){
          axios.get(this.$apibase+'gen/biblioteca/', {
            params: {
              'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.procesarbiblioteca(response),  response => this.errorprocesarpedidos(response) )
          .catch( response => this.errorprocesarpedidos(response))
      } else {
        errorprocesarpedidos ('notcred')
      }
    },
    procesarbiblioteca (response) {
      if(response.data.estado === 1){
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias)
      }
    },
    errorprocesarpedidos (response) {
      
    },
    guardarbiblioteca: function () {
      if (this.verificarformb && this.$store.getters.escarpintero === true){
          
          axios.post(this.$apibase+'gen/enviarbiblioteca', {
            "categoria": this.carpeta, "pedido": this.idnuevo, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
          })
          .then( response => this.pasoguardar(response),  response => this.errorguardar(response) )
          .catch( response => this.errorguardar(response))
      }
    },
    pasoguardar (response){
      if (response.data.estado === 1){
        this.alertapedidoguardado = 1
        this.carpeta = 0
        this.biblioteca = 0
        if (response.data.pedidoviejo.idproveedor === 1) {
          this.sologuardar = 1
          this.pedido = response.data.pedidoviejo
        }
      }

    },
    errorguardar (reponse) {
      
    },
    descargararchivo: function () {

    },
    iralarchivo(archivo){
      window.open(archivo, '_blank');
    }
  },
  computed: {
    urldescarga: function () {
      return this.pedido.urlarchivo
    },
     verificarformb: function (event) {
      this.errores = []
      
      if (this.biblioteca < '1') {
        this.errores.push("Seleccione si desea guardar")
      }
      if (this.biblioteca === '1' && this.carpeta <= 0) {
       this.errores.push("Seleccione una Carpeta") 
      }
      
      if(!this.errores.length) {
        return true
      } else {
        return false
      }
    },
    categoriasbiblioteca () {
      if (this.biblioteca === '1') {
        if(this.$store.getters.categorias[1] !== undefined) {
          return _.orderBy(this.$store.getters.categorias, ['id'], ['desc'])
        } else {
          this.consultarbiblioteca()
          return _.orderBy(this.$store.getters.categorias, ['id'], ['desc'])
        }
      }
    }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/pedidocompleto.js